{
    "apply": "Appliquer",
    "top_navbar__search-placeholder": "Rechercher clients, articles, commandes, etc.",
    "top_navbar__new_actvity": "Créer",
    "top_navbar__new_task": "Nouvelle tâche",
    "top_navbar__new_draft": "Nouveau brouillon",
    "top_navbar__new_event": "Planifier un rendez-vous",
    "top_navbar__new_note": "Enregistrer une interaction",
    "search__label__customers": "Clients",
    "search__label__products": "Articles",
    "search__label__sales_orders": "Commandes",
    "search__label__sales_quotes": "Devis",
    "search__label__all": "Tous",
    "search__clear": "Effacer la recherche",
    "search__match_label__contact": "Contact",
    "search__match_label__address": "Adresse",
    "search__match_label__supplier": "Fournisseur",
    "search__match_label__purchase_order_number": "N° de commande",
    "search__match_label__po_number": "N° de commande client",
    "search__match_label__gtin": "GTIN",
    "search__match_label__ean": "EAN",
    "table_count_results_plural": "Résultats",
    "table_count_results_singular": "Résultat",
    "table_more_results": "Plus de résultats",
    "page_title__home": "Accueil",
    "page_title__customers": "Clients",
    "page_title__product_details": "Détails du produit",
    "page_title__sales_quotes": "Devis",
    "page_title__sales_orders": "Commandes",
    "page_title__explorer": "Analyse des ventes",
    "page_title__sales_drafts": "Brouillons",
    "page_title__tasks": "Tâches",
    "page_title__drafts": "Brouillons",
    "page_title__transactions": "Transactions",
    "page_title__events": "Rendez-vous",
    "page_title__activities": "Activités",
    "page_title__my_activity": "Mon activité",
    "nav_group__steer": "Piloter",
    "nav_group__analyze": "Analyser",
    "nav__expand": "Agrandir la navigation",
    "data_freshness__stale": "Les données peuvent ne pas être à jour",
    "data_freshness__stale_detail_one": "Aucune nouvelle commande n'a été importée dans Plato depuis plus d'un jour. Contactez votre service informatique si le problème persiste.",
    "data_freshness__stale_detail_many": "Aucune nouvelle commande n'a été importée dans Plato depuis plus de {{count}} jours. Contactez votre service informatique si le problème persiste.",
    "data_freshness__stale_detail_other": "Aucune nouvelle commande n'a été importée dans Plato depuis plus de {{count}} jours. Contactez votre service informatique si le problème persiste.",
    "view_switch__view_as_label": "Vue",
    "view_switch__manager": "Manager",
    "view_switch__sales_rep": "Commercial",
    "view_switch__rep_only_page_toast": "Cette page n'est visible qu'en vue commercial",
    "view_switch__manager_only_page_toast": "Cette page n'est visible qu'en vue manager",
    "page_sub_title__home": "Ici, vous voyez comment se passent votre journée et votre mois et quels clients ont besoin d'attention en ce moment. Vos chiffres du jour et du mois, les tâches à échéance et les clients en croissance ou en recul. Cliquez sur une tuile ou un client pour les détails.",
    "page_sub_title__customers": "Ici, vous trouvez lesquels de vos clients ont besoin d'un rendez-vous en priorité. Vous voyez les clients dont vous êtes responsable, avec leurs chiffres et leur statut comme dans votre ERP. Les vues rapides ci-dessus sont des listes toutes prêtes pour cela.",
    "page_sub_title__sales_quotes": "Ici, vous gardez un œil sur les devis de vos clients encore ouverts et à relancer. Ils proviennent de votre ERP. Filtrez la liste comme vous en avez besoin et enregistrez-la comme vue pour la prochaine fois.",
    "page_sub_title__sales_orders": "Ici, vous voyez ce que vos clients ont commandé et si une commande est encore ouverte ou déjà facturée. Les commandes proviennent de votre ERP. Filtrez la liste comme vous en avez besoin et enregistrez-la comme vue pour la prochaine fois.",
    "page_sub_title__explorer": "Ici, vous voyez sur quoi repose votre activité et où elle recule par rapport à l'an dernier, par client, article et plus, comme dans votre ERP. Choisissez une ligne comme filtre et les autres onglets n'affichent plus que ce qui s'y rattache.",
    "page_sub_title__customer_explorer": "Ici, vous voyez sur quoi repose l'activité de ce client avec vous et où elle recule par rapport à l'an dernier, par article et plus. Choisissez une ligne comme filtre et les autres onglets n'affichent plus que ce qui s'y rattache.",
    "page_sub_title__tasks": "Ici, vous voyez ce qu'il faut faire aujourd'hui et ce qui reste à venir. Vos tâches se trouvent sous Aujourd'hui, À venir et Terminées. Le nombre rouge dans la navigation compte vos tâches ouvertes à échéance aujourd'hui ou avant.",
    "page_sub_title__drafts": "Ici, vous reprenez un devis ou une commande là où vous vous étiez arrêté. Les brouillons sont ce que vous avez commencé dans Plato sans l'avoir encore transmis à l'ERP. Ce n'est qu'après la transmission qu'ils y figurent et comptent.",
    "page_sub_title__events": "Ici, vous planifiez vos visites et réunions chez les clients. Un rendez-vous ne compte comme visite chez le client qu'une fois que vous l'avez consigné.",
    "page_sub_title__activities": "Interactions enregistrées, tâches terminées, recommandations commerciales et changements de statut client de toute l'équipe. Les devis et commandes ne sont pas inclus. Les rendez-vous planifiés, les tâches ouvertes et les notes épinglées n'apparaissent pas ici non plus : retrouvez-les sous Tâches et sur la page client.",
    "page_sub_title__my_activity": "Vos interactions enregistrées, tâches terminées, recommandations commerciales et changements de statut client. Les devis et commandes ne sont pas inclus. Les rendez-vous planifiés, les tâches ouvertes et les notes épinglées n'apparaissent pas ici non plus : retrouvez-les sous Tâches et sur la page client.",
    "empty_table__no_results": "Aucun résultat",
    "form__submit": "Confirmer",
    "form__cancel": "Annuler",
    "form__close": "Fermer",
    "form__undo": "Annuler",
    "form__delete": "Supprimer",
    "form__release": "Valider",
    "show_results": "Afficher les résultats",
    "show_more": "Afficher plus",
    "show_less": "Afficher moins",
    "no_data": "Aucune donnée",
    "nothing_found": "Aucun résultat",
    "loading": "Chargement",
    "loading_dots": "Chargement...",
    "submit": "Envoyer",
    "search": "Recherche",
    "quote": "Devis",
    "sales_quote": "Devis",
    "order": "Commande",
    "sales_order": "Commande",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "tomorrow": "Demain",
    "difference": "Écart",
    "back": "Retour",
    "ascending": "Croissant",
    "descending": "Décroissant",
    "placeholder__select_date": "Sélectionner une date...",
    "description": "Description",
    "logout__button": "Se déconnecter",
    "exit_demo__button": "Quitter la démo",
    "support__button": "Aide",
    "customer_mode__button": "Masquer les marges",
    "related_to": "Lié à",
    "assigned_to_user": "assigné à {{user}}",
    "assigned_to": "Assigné à",
    "placeholder__select_customer": "Sélectionner un client...",
    "form__customer_required": "Veuillez sélectionner un client",
    "form__text_required": "Veuillez saisir un texte",
    "form__date_required": "Veuillez sélectionner une date",
    "form__assignee_required": "Veuillez sélectionner un utilisateur",
    "vs_lytd": "par rapport à la même période l'an dernier",
    "vs_previous_12_months": "par rapport aux 12 mois précédents",
    "last_12_months": "12 derniers mois",
    "previous_12_months": "12 mois précédents",
    "total_amount": "Total",
    "due_date": "Date limite",
    "task": "Tâche",
    "scheduled_by_user": "planifié par {{user}}",
    "logged_by_user": "enregistré par {{user}}",
    "customer": "Client",
    "article": "Article",
    "product": "Article",
    "storage_location": "Entrepôt",
    "sales_draft__new_form___title": "Nouvelle transaction",
    "sales_draft__new_form___storage_location": "Entrepôt",
    "sales_draft__new_form___customer": "Client",
    "sales_draft__new_form___type": "Type",
    "sales_draft__new_form___order": "Commande",
    "sales_draft__new_form___quote": "Devis",
    "erp_connection_error_banner___title": "Création de brouillons/commandes désactivée",
    "erp_connection_error_banner___description": "Plato ne parvient pas à se connecter à l'ERP. Veuillez contacter votre administrateur informatique.",
    "placeholder__select_storage": "Sélectionner un entrepôt...",
    "backorder": "Reliquat",
    "search_product": "Rechercher des articles",
    "copy_id_tooltip": "Copier l'ID dans le presse-papiers",
    "copy_tooltip": "Copier dans le presse-papiers",
    "all_changes_saved": "Toutes les modifications sont enregistrées",
    "saving_failed": "Échec de l'enregistrement",
    "time_picker__time_option": "{{time}}",
    "time_picker__placeholder": "Sélectionner une heure",
    "toast__created_success_body": "Vous pouvez l'afficher <linkTag>ici</linkTag>",
    "toast__edited_success_body": "Vous pouvez l'afficher <linkTag>ici</linkTag>",
    "toast__deleted_success_body": "Vous pouvez en créer une nouvelle <linkTag>ici</linkTag>",
    "filter_view_updated_title": "Vue enregistrée et appliquée.",
    "print": "Imprimer",
    "show_all": "Tout afficher",
    "voice__start_recording": "Démarrer l'enregistrement",
    "voice__mic_error_title": "Impossible de démarrer l'enregistrement",
    "voice__mic_error_description": "Nous n'avons pas pu accéder à votre microphone. Veuillez vérifier les autorisations de votre navigateur et réessayer.",
    "voice__transcription_error_title": "Impossible de convertir l'enregistrement en texte",
    "voice__transcription_error_description": "Veuillez réessayer. Si le problème persiste, saisissez votre note.",
    "voice__recording_title": "Enregistrement",
    "voice__processing": "Traitement de l'enregistrement …",
    "voice__done": "Terminé",
    "rich_text_editor__enter_url": "Saisir l'URL :",
    "rich_text_editor__format_bold": "Gras",
    "rich_text_editor__format_italic": "Italique",
    "rich_text_editor__format_underline": "Souligné",
    "rich_text_editor__format_strikethrough": "Barré",
    "rich_text_editor__insert_bullet_list": "Liste à puces",
    "rich_text_editor__insert_numbered_list": "Liste numérotée",
    "rich_text_editor__insert_link": "Lien",
    "rich_text_editor__more_options": "Plus d'options",
    "rich_text_editor__clear": "Effacer la saisie",
    "rich_text_editor__improve_writing_loading": "Amélioration du texte en cours",
    "rich_text_editor__improve_writing": "Améliorer le texte",
    "rich_text_editor__heading_summary": "Résumé :",
    "rich_text_editor__heading_opportunities": "Opportunités :",
    "rich_text_editor__heading_feedback": "Retours :",
    "rich_text_editor__heading_next_steps": "Prochaines étapes :",
    "rich_text_editor__rate_suggestion": "Comment évaluez-vous cette suggestion ?",
    "rich_text_editor__thumbs_up": "Pouce levé",
    "rich_text_editor__thumbs_down": "Pouce baissé",
    "rich_text_editor__alternative": "Alternative",
    "rich_text_editor__insert": "Insérer",
    "rich_text_editor__feedback_thank_you": "Merci pour votre retour",
    "show_details": "Afficher les détails",
    "status_new": "Nouveau",
    "status_active": "Actif",
    "status_at_risk": "À risque",
    "status_inactive": "Inactif",
    "status_blocked": "Bloqué",
    "status_dormant": "En sommeil",
    "view_customer": "Afficher le client",
    "more": "de plus",
    "yes_no__true": "Oui",
    "yes_no__false": "Non",
    "not_set": "Non défini",
    "select_user": "Sélectionner un utilisateur",
    "select_team_member": "Sélectionner un membre de l'équipe",
    "you": "Vous",
    "writeback_error": "Une erreur est survenue lors de la connexion à l'ERP",
    "attachments__label": "Pièces jointes",
    "attachments__add_files": "Ajouter des fichiers",
    "attachments__load_error": "Impossible de charger le fichier",
    "discard_changes__title": "Abandonner les modifications non enregistrées ?",
    "discard_changes__description": "Toutes les données non enregistrées seront perdues.",
    "discard_changes__confirm": "Abandonner les modifications",
    "not_found_page__title": "Page introuvable",
    "not_found_page__description": "Désolé, nous n'avons pas trouvé la page recherchée.",
    "not_found_page__back_home": "Retour à l'accueil",
    "not_found_drawer__title": "Contenu introuvable",
    "not_found_drawer__description": "Désolé, nous n'avons pas trouvé le contenu recherché.",
    "error_page__title": "Erreur",
    "error_page__description": "Désolé, une erreur est survenue (ID d'erreur : {{eventId}}) :",
    "error_page__try_again": "Réessayer",
    "mobile_nav__more": "Plus",
    "nav__webshop": "Boutique en ligne",
    "carousel__previous_slide": "Élément précédent",
    "carousel__next_slide": "Élément suivant",
    "aria__main_navigation": "Navigation principale",
    "aria__remove": "Supprimer",
    "aria__select_row": "Sélectionner la ligne",
    "aria__tabs": "Onglets"
}
